import { Component, OnInit } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { AuthStateService } from './auth-state.service'
import { CommonModule } from '@angular/common'
import { SpinnerComponent } from './shared/components/spinner/spinner.component'
import { HomeComponent } from './sections/home/home.component'
import { CanvasComponent } from './canvas/canvas.component'
import { LoadingService } from './shared/components/loading.service'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, CanvasComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  isLoading: boolean | null = true
  constructor(
    private loadingService: LoadingService,
    private authStateService: AuthStateService,
  ) {
    this.authStateService.checkLoginStatus()
  }
  ngOnInit(): void {
    this.loadingService.loading$.subscribe((loading) => {
      this.isLoading = loading
    })
  }

  title = 'ArihantCRM'
}
